import { ActionBar } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

type GoBackToVisitActionProps = {
   readonly visitId: number;
};

export const GoBackToVisitAction = (props: GoBackToVisitActionProps): JSX.Element => {
   return (
      <ActionBar.GoBackActionLink
         label='visit:goBackToVisit'
         to={visitPaths.getVisitInterviewPath({
            params: { visitId: props.visitId },
         })}
      />
   );
};
